var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-nav"},[_c('static-banner',{attrs:{"image_banner":_vm.image_banner,"main-title":"媒体报道","sub-title":"以下是相关媒体对我们的报道"}}),_c('NewsContent',{attrs:{"news-type":"2","content-title":"媒体报道"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }